/**
 * Session token devir alma.
 *
 * Panel runner'a soyle yonlendirir:
 *   https://run.ecup.me/s/{sessionCode}#t={token}
 *
 * Token fragment'ta tasinir cunku fragment sunucuya hic gonderilmez: access
 * loglarina, Referer basligina ve proxy loglarina dusmez.
 *
 * Okunduktan sonra sessionStorage'a alinir ve URL'den temizlenir.
 * sessionStorage tercihi bilincli: sayfa yenilemesini atlatir, sekme kapaninca
 * silinir, sekmeler arasi paylasilmaz.
 */

const TOKEN_KEY_PREFIX = "ecup.runner.token.";

function storageKey(sessionCode: string): string {
  return TOKEN_KEY_PREFIX + sessionCode;
}

/** URL'den session kodunu okur: /s/{sessionCode} */
export function readSessionCodeFromUrl(pathname: string): string | null {
  const match = /^\/s\/([A-Za-z0-9_-]+)\/?$/.exec(pathname);
  return match?.[1] ?? null;
}

/** URL'den çalışma programı kodunu okur: /calisma-programi/{sessionCode} */
export function readStudyProgramCodeFromUrl(pathname: string): string | null {
  const match = /^\/calisma-programi\/([A-Za-z0-9_-]+)\/?$/.exec(pathname);
  return match?.[1] ?? null;
}

/** Fragment'tan token'i okur: #t={token} */
export function readTokenFromHash(hash: string): string | null {
  if (!hash || hash.length < 2) return null;
  const params = new URLSearchParams(hash.slice(1));
  const token = params.get("t");
  return token && token.length > 0 ? token : null;
}

/**
 * Devir alma: fragment'ta token varsa sakla ve URL'i temizle.
 * Token yoksa daha once saklanmis olani dondurur (yenileme durumu).
 */
export function claimToken(sessionCode: string): string | null {
  const fromHash = readTokenFromHash(window.location.hash);

  if (fromHash) {
    window.sessionStorage.setItem(storageKey(sessionCode), fromHash);
    // Fragment'i gecmise yeni kayit eklemeden sil.
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search,
    );
    return fromHash;
  }

  return window.sessionStorage.getItem(storageKey(sessionCode));
}

/** Saklanan token'daki öğrenci Id'si (student_id); yoksa null. İmza doğrulanmaz, yalnız yönlendirme içindir. */
export function readStudentIdFromToken(sessionCode: string): number | null {
  const token = window.sessionStorage.getItem(storageKey(sessionCode));
  const payload = token?.split(".")[1];
  if (!payload) return null;
  try {
    const json = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    const id = Number(json.student_id);
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function clearToken(sessionCode: string): void {
  window.sessionStorage.removeItem(storageKey(sessionCode));
}
